import { render, staticRenderFns } from "./chat_customer.vue?vue&type=template&id=2fa69c7f&scoped=true&"
import script from "./chat_customer.vue?vue&type=script&lang=js&"
export * from "./chat_customer.vue?vue&type=script&lang=js&"
import style0 from "./chat_customer.vue?vue&type=style&index=0&id=2fa69c7f&prod&scoped=true&lang=css&"
import style1 from "./chat_customer.vue?vue&type=style&index=1&id=2fa69c7f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa69c7f",
  null
  
)

export default component.exports